(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('ValueReportController', ValueReportController);

	ValueReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state', '$timeout', '$location', '$anchorScroll'];

	function ValueReportController($window, WineRepository, $log, lodash, $state, $timeout, $location, $anchorScroll){

		/* jshint validthis: true */
		var self = this;

		self.wineGroupedByPriceRange = {};
		self.totalBottles = 0;
		self.totalWines = 0;
		self.groupNames = {
			'0': '$0',
			'10': '$10 and under',
			'25': '$10-24',
			'50': '$25-49',
			'75': '$50-74',
			'100': '$75-99',
			'150': '$100-149',
			'200': '$150-199',
			'500': '$200-499',
			'$500 and up': '$500 and up'
		};

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.report = {
			selectedView: 'low-high',
			loading: true,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.jumpTo = jumpTo;

		self.print = print;

		self.updateView = updateView;

		self.initialize = initialize;

		/** initialize */
		initialize();

		/** begin methods */

		function initialize() {
			self.report.availableViews = {
				'low-high': "Cost Low-High",
				'high-low': "Cost High-Low"
			};

			_resetReport();

			// @todo convert from wine.purchase.price to wine.value
			// we don't need to dig into the purchase, just keep it simply at the value! :)

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / On Order',
							'Average Purchase Price',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// we need -1 because we are doing a > not a >= comparison, there are many 0's that will
						// only fire on -1.
						var ranges = [500, 200, 150, 100, 75, 50, 25, 10, 0, -1];

						lodash.forEach(wineEntities, function(wine) {
							// @todo when do we keep, when don't we?
							// I think you must have 1 qty.
							if (wine.cellar.qty > 0) {
								var winner = '$500 and up';
								_.forEach(ranges, function (range) {
									if (wine.cellar.value >= range) {
										// add to obj tracking prices
										if (!lodash.isArray(self.wineGroupedByPriceRange[winner])) {
											self.wineGroupedByPriceRange[winner] = [];
										}
										// @todo
										// purchase.qty > wine.cellar.qty
										// purchase.price > wine.cellar.value
										// purchase.wine > wine
										self.wineGroupedByPriceRange[winner].push(wine);
										return false;
									}
									// the previous range now is the winner
									winner = range;
								});
							}
						});

						self.totalBottles = lodash.sum(self.wineGroupedByPriceRange, function(wines) {
							return lodash.sum(wines, function(wine) {
								// Bottles: in the celler
								return wine.cellar.qty;
							});
						});

						self.totalWines = lodash.sum(self.wineGroupedByPriceRange, function(wines) {
							return wines.length;
						});

						_updateReport();

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});
		}

		function _updateReport() {
			var keyName = 'Price Group';
			var keyNamePlural = keyName + 's';

			// initialize totals
			var grandTotals = {
				bottlesInCellar: self.totalBottles,
				value: 0,
				groupCount: Object.keys(self.wineGroupedByPriceRange).length,
				wines:  self.totalWines
			};

			var forEachType = 'forEach';

			if (self.report.selectedView === 'high-low') {
				forEachType = 'forEachRight';
			}

			// @todo convert to an array so we can ensure order
			lodash[forEachType](self.wineGroupedByPriceRange, function(wines, maxCost) {
				var groupTotals = {
					bottlesInCellar: 0,
					value: 0
				};

				// total value for grouping
				// @todo convert to?
				// combine this with the grand totals?
				groupTotals.value = lodash.sum(wines, function(wine) {
					return wine.cellar.qty * wine.cellar.value;// doesn't work! wine.totalValue; // was `wine.cellar.qty * wine.cellar.value;` which may be more accurate?
				});

				// update grand total value
				grandTotals.value += groupTotals.value;

				var formattedWines = [];

				lodash.forEach(wines, function(wine) {
					var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
					var category = (wine.category && wine.category.name) ? wine.category.name : '';
					var type = varietal + category;

					var avgPurchasePriceFloat = window.numeral(wine.avgPurchasePrice());
					var valueGainFormatted = wine.getRelativeGainPercentFormatted(avgPurchasePriceFloat);
					var valueGainClass = wine.getValueGainClass(avgPurchasePriceFloat);

					groupTotals.bottlesInCellar += wine.cellar.qty;

					// data we want to display on a single wine
					formattedWines.push({
						name: wine.getFullName(),
						appelation: wine.getFullAppellation(),
						type: type,
						size: wine.bottleSize.name,
						bottlesInCellar: wine.cellar.qty,
						qtyOnOrder: wine.getOnOrderQty(),
						averagePurchasePrice: $window.numeral(wine.avgPurchasePrice()).format('$0,0[.]00'), // @todo get avg pp
						value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
						gain: valueGainFormatted,
						gainClass: valueGainClass
					});
				});

				self.report.groups.push({
					groupName: self.groupNames[maxCost],
					bottlesInCellar: groupTotals.bottlesInCellar,
					value: $window.numeral(groupTotals.value).format('$0,0[.]00'),
					wines: formattedWines
				});

			});

			// @todo sort self.report.groups by .groupName
			self.report.totals = [
				// 'GroupName / Wine',
				'Total ' + keyNamePlural + ': ' + grandTotals.groupCount + '<br/>Total wines: ' + grandTotals.wines,
				// 'Size',
				null,
				// 'Bottles',
				'Total Bottles In Cellar: ' + grandTotals.bottlesInCellar,
				// 'Average Cost',
				null,
				// 'Value',
				$window.numeral(grandTotals.value).format('$0,0[.]00'),
				// 'Gain / Loss'
				null
			];

			// hide loading
			self.report.loading = false;
		}

		function updateView() {
			// remove existing groupings
			self.report.groups = [];

			// show loading
			self.report.loading = true;

			// let dom update to show loading
			$timeout(function(){
				// update
				_updateReport();
			});
		}

		function _resetReport() {
			// remove existing groupings
			self.report.groups = [];
			self.wineGroupedByPriceRange = {};

			// show loading
			self.report.loading = true;

			// reset totals
			self.totalBottles = 0;
			self.totalWines = 0;
		}

		function jumpTo(id) {
			$location.hash('item-' + id);
			$anchorScroll();
		}

		function print(){
			return $window.print();
		}
	}

})();
